import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Login() {
  const [isSignUp, setIsSignUp] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/dashboard'; // ✅ Get intended path or fallback to /dashboard

  // ✅ Check if already logged in and redirect
  useEffect(() => {
    const checkSessionAndRedirect = async () => {
      const { data } = await supabase.auth.getSession();
      const session = data?.session;
      if (session?.user) {
        navigate(from, { replace: true });
      }
    };
    checkSessionAndRedirect();
  }, [navigate, from]);

  const handleAuth = async (e) => {
    e.preventDefault();
    setLoading(true);

    let result;
    if (isSignUp) {
      result = await supabase.auth.signUp({ email, password });
    } else {
      result = await supabase.auth.signInWithPassword({ email, password });
    }

    if (result.error) {
      alert(result.error.message);
    } else {
      alert(isSignUp ? '✅ Sign-up successful! Check email to confirm.' : '✅ Logged in!');
      navigate(from, { replace: true }); // ✅ Redirect to intended page
    }

    setLoading(false);
  };

  const handleGoogleLogin = async () => {
    setLoading(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/login`, // Adjust if you have a different callback path
      }
    });
    if (error) alert(error.message);
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>{isSignUp ? 'Create Account' : 'Login'}</h2>

        <div style={styles.tabs}>
          <button
            style={{ ...styles.tab, backgroundColor: !isSignUp ? '#ddd' : '#fff' }}
            onClick={() => setIsSignUp(false)}
          >
            Login
          </button>
          <button
            style={{ ...styles.tab, backgroundColor: isSignUp ? '#ddd' : '#fff' }}
            onClick={() => setIsSignUp(true)}
          >
            Sign Up
          </button>
        </div>

        <form onSubmit={handleAuth}>
          <input
            type="email"
            placeholder="Email"
            style={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            style={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Please wait...' : isSignUp ? 'Sign Up' : 'Login'}
          </button>
        </form>

        <hr style={{ margin: '20px 0' }} />
        <button style={styles.googleBtn} onClick={handleGoogleLogin} disabled={loading}>
          {loading ? 'Redirecting...' : 'Login with Google'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    paddingTop: 80,
    display: 'flex',
    justifyContent: 'center',
  },
  card: {
    width: 400,
    padding: 30,
    border: '1px solid #ccc',
    borderRadius: 8,
    textAlign: 'center',
    backgroundColor: '#f9f9f9',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  input: {
    width: '100%',
    padding: 10,
    marginBottom: 12,
    border: '1px solid #ccc',
    borderRadius: 4,
  },
  button: {
    width: '100%',
    padding: 10,
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
  },
  googleBtn: {
    width: '100%',
    padding: 10,
    backgroundColor: '#db4437',
    color: 'white',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
  },
  tabs: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 20,
  },
  tab: {
    flex: 1,
    padding: 10,
    border: '1px solid #ccc',
    borderBottom: 'none',
    cursor: 'pointer',
  },
};
